'use client'

import { ReactElement, useCallback, useSyncExternalStore } from 'react'

import { Carat, RotateClockwise } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../_providers/TranslationProvider.client'

import { NextControl, PrevControl } from './styles'

import type { Swiper as SwiperInstance } from 'swiper'

export const CarouselControls = ({
  swiperRef,
}: {
  swiperRef: React.RefObject<SwiperInstance | null>
}): ReactElement => {
  const {
    magnolia: {
      general: { nextAriaLabel, previousAriaLabel },
    },
  } = useTranslation()

  const subscribe = useCallback(
    (callback: () => void) => {
      const swiper = swiperRef.current
      if (!swiper) return () => {}
      swiper.on('transitionEnd', callback)
      return () => swiper.off('transitionEnd', callback)
    },
    [swiperRef]
  )

  const isBeginning = useSyncExternalStore(
    subscribe,
    () => swiperRef.current?.isBeginning ?? true,
    () => true
  )

  const isEnd = useSyncExternalStore(
    subscribe,
    () => swiperRef.current?.isEnd ?? false,
    () => false
  )

  return (
    <>
      {
        <PrevControl
          onClick={() => swiperRef.current?.slidePrev()}
          variant='black-on-white'
          size='medium'
          aria-label={previousAriaLabel}
          disabled={isBeginning}
        >
          <Carat
            style={{ minWidth: '9px', minHeight: '9px' }}
            rotateClockwise={RotateClockwise.Half}
          />
        </PrevControl>
      }
      {
        <NextControl
          onClick={() => swiperRef.current?.slideNext()}
          variant='black-on-white'
          size='medium'
          aria-label={nextAriaLabel}
          disabled={isEnd}
        >
          <Carat style={{ minWidth: '9px', minHeight: '9px' }} />
        </NextControl>
      }
    </>
  )
}
